module.exports = __webpack_public_path__ + "static/media/298290.83dac685.png";